import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../store";
import { loginLyfshortFetchedUser, logout, loginSuccess } from "../auth/authSlice";
import { LyfshortUserProfile, UserProfile } from "../../../types/authState";

interface UserState {
  lyfshortUser: LyfshortUserProfile | null;
  body: UserProfile | null;
  updating: number;
}

const initialState: UserState = {
  lyfshortUser: null,
  updating: 0,
  body: null,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    fetchUserSuccess: (state, action) => {
      state.lyfshortUser = action.payload.user
    },
    fetchUserFailed: (state, action) => { },
    updateUser: (state, action) => {
      state.updating = state.updating + 1
    },
    updateUserMeta: (state, action) => {
      state.updating = state.updating + 1
    },
    updateUserSuccess: (state, action) => {
      state.lyfshortUser = action.payload
      state.updating = state.updating - 1
    },
    updateUserFailed: (state, action) => {
      state.updating = state.updating - 1
    },
    checkUserEmailVerification: (state, action) => {
      // TODO
    },
    checkUserEmailVerificationSuccess: (state, action) => {
      state.lyfshortUser = action.payload.user
    },
    checkUserEmailVerificationFailed: (state) => {
      // TODO
    },
    fetchTriplinkUserSuccess: (state, action) => {
      state.body = action.payload
    },
    fetchTriplinkUserFailed: (state, action) => {
      state.body = null
    }
  },
  extraReducers(builder) {
    builder
    .addCase(logout, (state, action) => {
      state.lyfshortUser = null
      state.updating = 0
      state.body = null
    })
    .addCase(loginLyfshortFetchedUser, (state, action) => {
      state.lyfshortUser = action.payload.user
    })
    .addCase(loginSuccess, (state, action) => {
      state.body = action.payload
    })
  },
})

export const {
  fetchUserSuccess,
  fetchUserFailed,
  updateUser,
  updateUserMeta,
  updateUserSuccess,
  updateUserFailed,
  checkUserEmailVerification,
  checkUserEmailVerificationSuccess,
  checkUserEmailVerificationFailed,
} = userSlice.actions

export const selectUser = (state: RootState) => state.user
export default userSlice.reducer